import { useAppSelector } from '@shared/store';
import { selectAccountLoading } from '@entities/account';

export const useAccountLoading = () => {
  const loading = useAppSelector(selectAccountLoading);

  return loading;
};
